// /var/www/aesirerp_lp/frontend/src/app/page.tsx
"use client";

import { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { ScrollAnimator } from '@/components/ScrollAnimator';
import styles from './Page.module.css';
import { ParticleBackground } from '@/components/ParticleBackground';
import { PricingCalculator } from '@/components/PricingCalculator';
import { 
  Truck, Handshake, ShoppingCart, DollarSign, Users, Wrench, Target, 
  MessageSquare, Sparkles, ArrowRight, XCircle, CheckCircle2, Zap, 
  Bot, Smartphone, Banknote, Warehouse, ArrowLeftRight, Cog, 
  HandCoins, Copy, Check, Phone, Plus, FileText 
} from 'lucide-react';
import { SiIfood, SiMeta, SiGoogle } from 'react-icons/si';
import { FaWhatsapp } from 'react-icons/fa';

import { IntroAnimation } from '@/components/hero/IntroAnimation';
import { HeroSection } from '@/components/hero/HeroSection';
import { Comparison } from '@/components/comparison/Comparison';
import { Ecosystem } from '@/components/ecosystem/Ecosystem';
import { BentoEcosystem } from '@/components/ecosystem/BentoEcosystem';
import { Faq } from '@/components/faq/Faq';
import { Testimonials } from '@/components/testimonials/Testimonials';

import { VendasModule } from '@/components/modules/VendasModule';
import { ChatModule } from '@/components/modules/ChatModule';
import { CampaignsModule } from '@/components/modules/CampaignsModule';
import { GestaoModule } from '@/components/modules/GestaoModule';
import { ServicosModule } from '@/components/modules/ServicosModule';
import { CrmModule } from '@/components/modules/CrmModule';
import { RhModule } from '@/components/modules/RhModule';
import { AutomationsModule } from '@/components/modules/AutomationsModule';
import { CtaFinal } from '@/components/CtaFinal';
import { DataPipeline } from '@/components/ecosystem/DataPipeline'; // <-- Importe o novo

export default function Home() {
  const handleCopy = () => {
    navigator.clipboard.writeText("AESIR-VIP-2026");
    alert("Código copiado!");
  };

  return (
    <>

      <IntroAnimation />

      <HeroSection />

      <BentoEcosystem />

      <DataPipeline />
      {/* ===== SOLUÇÕES (Z-PATTERN LAYOUT) ===== */}
      {/* AQUI COMEÇA O Z-PATTERN DOS DETALHES DOS MÓDULOS */}
      <section id="modulos" className={`${styles.section} ${styles.modulosSection}`} style={{ padding: '6rem 0' }}>
        
        {/* CAMADA DE ÍCONES FLUTUANTES (FUNDO VIVO E ORGÂNICO) */}
        <div className={styles.floatingIconsLayer}>
           <ShoppingCart className={`${styles.floatIcon} ${styles.icon1}`} />
           <MessageSquare className={`${styles.floatIcon} ${styles.icon2}`} />
           <DollarSign className={`${styles.floatIcon} ${styles.icon3}`} />
           <Users className={`${styles.floatIcon} ${styles.icon4}`} />
           <Wrench className={`${styles.floatIcon} ${styles.icon5}`} />
        </div>

        {/* O CONTEÚDO REAL FICA SOBREPOSTO (z-index: 1) */}
        <div className={styles.container} style={{ position: 'relative', zIndex: 1 }}>
          
          {/* TÍTULO AJUSTADO E ELEGANTE (MATERIAL DESIGN 3) */}
          <div className={styles.sectionTitle} style={{ marginBottom: '5rem', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ background: '#fff7ed', color: '#ea580c', padding: '6px 16px', borderRadius: '50px', fontSize: '0.75rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px' }}>
              Ecossistema Modular
            </div>
            <h2 style={{ fontSize: '2.25rem', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em', lineHeight: 1.2, margin: 0 }}>
              Escale sua operação <br/>
              <span style={{ color: '#ea580c' }}>no automático.</span>
            </h2>
            <p style={{ fontSize: '1rem', color: '#64748b', maxWidth: '600px', margin: '1rem auto 0 auto', lineHeight: 1.6 }}>
              Do disparo de milhares de campanhas no WhatsApp até a emissão da nota fiscal. Todas as ferramentas que você precisa em uma única tela.
            </p>
          </div>

          {/* O Layout em Escada (Z-Pattern). Passando reverse={true} para intercalar esquerda/direita */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8rem' }}>
            <ScrollAnimator><CampaignsModule reverse={false} /></ScrollAnimator>
            <ScrollAnimator><ChatModule reverse={true} /></ScrollAnimator>
            <ScrollAnimator><VendasModule reverse={false} /></ScrollAnimator>
            <ScrollAnimator><CrmModule reverse={true} /></ScrollAnimator>
            <ScrollAnimator><GestaoModule reverse={false} /></ScrollAnimator>
            <ScrollAnimator><ServicosModule reverse={true} /></ScrollAnimator>
            <ScrollAnimator><RhModule reverse={false} /></ScrollAnimator>
          </div>

        </div>
      </section>

      <Comparison />
      
      <AutomationsModule />

      <Ecosystem />

      {/* Integrações */}
      <section className={styles.section} style={{padding: '3rem 0', background: 'white', overflow: 'hidden'}}>
        <div className={styles.container}>
          <p style={{textAlign: 'center', marginBottom: '2rem', color: 'var(--md-sys-color-on-surface-variant)', fontWeight: '600', textTransform: 'uppercase', fontSize: '0.8rem', letterSpacing: '2px'}}>
            Conectado de forma nativa com as gigantes do mercado
          </p>
          <ScrollAnimator>
            <div className={styles.marqueeContainer}>
              <div className={styles.marqueeTrack}>
                <div className={styles.integrationItem} style={{color: '#EA1D2C'}}><SiIfood size={36} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>iFood</h3></div>
                <div className={styles.integrationItem} style={{color: '#1877F2'}}><SiMeta size={36} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>Meta</h3></div>
                <div className={styles.integrationItem} style={{color: '#25D366'}}><FaWhatsapp size={36} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>WhatsApp</h3></div>
                <div className={styles.integrationItem}><div style={{background: '#2D3277', borderRadius: '6px', padding: '6px', display: 'flex', alignItems: 'center'}}><Handshake size={28} color="#FFE600" /></div><h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0, color: '#2D3277'}}>Mercado Livre</h3></div>
                <div className={styles.integrationItem} style={{color: '#2CB3F2'}}><Truck size={36} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>Melhor Envio</h3></div>
                <div className={styles.integrationItem} style={{color: '#4285F4'}}><SiGoogle size={32} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>Google API</h3></div>
                
                {/* Duplicado para o Loop */}
                <div className={styles.integrationItem} style={{color: '#EA1D2C'}}><SiIfood size={36} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>iFood</h3></div>
                <div className={styles.integrationItem} style={{color: '#1877F2'}}><SiMeta size={36} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>Meta</h3></div>
                <div className={styles.integrationItem} style={{color: '#25D366'}}><FaWhatsapp size={36} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>WhatsApp</h3></div>
                <div className={styles.integrationItem}><div style={{background: '#2D3277', borderRadius: '6px', padding: '6px', display: 'flex', alignItems: 'center'}}><Handshake size={28} color="#FFE600" /></div><h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0, color: '#2D3277'}}>Mercado Livre</h3></div>
                <div className={styles.integrationItem} style={{color: '#2CB3F2'}}><Truck size={36} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>Melhor Envio</h3></div>
                <div className={styles.integrationItem} style={{color: '#4285F4'}}><SiGoogle size={32} /> <h3 style={{fontWeight: 800, fontSize: '1.5rem', margin: 0}}>Google API</h3></div>
              </div>
            </div>
          </ScrollAnimator>
        </div>
      </section>

      {/* INDIQUE E GANHE E RESTO DA PÁGINA CONTINUAM AQUI... */}
      {/* ===== MONETIZAÇÃO: INDIQUE & WHITE LABEL ===== */}
      <section id="parceiros" className={styles.partnerSection}>
        <div className={styles.container}>
          
          <div className={styles.referralContainer}>
            
            <ScrollAnimator>
              <div className={styles.referralHeader}>
                <div className={styles.headerIcon}>
                  <HandCoins size={40} />
                </div>
                <h1 style={{fontSize: '3.5rem', fontWeight: 800, color: '#0f172a', marginBottom: '1rem', letterSpacing: '-1px'}}>
                  Monetize sua rede de contatos.
                </h1>
                <p style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '700px', margin: '0 auto', lineHeight: 1.6}}>
                  Transforme a tecnologia do Aesir ERP numa nova fonte de lucro. Indique e receba comissões automáticas ou crie a sua própria empresa de SaaS.
                </p>
              </div>
            </ScrollAnimator>

            {/* DASHBOARD: O GRID ORIGINAL */}
            <ScrollAnimator>
              <div className={styles.dashboardGrid}>
                
                {/* Card Esquerdo: Painel Falso */}
                <div className={styles.m3Card}>
                  <div className={styles.codeSection}>
                    <span style={{color: '#ea580c', background: '#ffedd5', padding: '4px 12px', borderRadius: '50px', fontSize: '0.75rem', fontWeight: 800, textTransform: 'uppercase'}}>
                      Painel do Parceiro
                    </span>
                    <h4 style={{fontSize: '1.5rem', fontWeight: 800, color: '#1e293b', margin: '1rem 0 0.5rem 0'}}>Compartilhe e Ganhe</h4>
                    <p style={{color: '#64748b', fontSize: '0.95rem'}}>Envie este código para seus indicados e garanta sua comissão recorrente.</p>
                    
                    <div className={styles.codePill}>
                      <div className={styles.codeText}>AESIR-VIP</div>
                      <button className={styles.copyBtn} onClick={handleCopy} title="Copiar código">
                        <Copy size={24} />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Lado Direito: Passos 1, 2, 3 */}
                <div className={styles.stepsContainer}>
                  <div className={styles.stepItem}>
                    <div className={styles.stepBadge}>1</div>
                    <div className={styles.stepInfo}>
                      <h3>Você Indica</h3>
                      <p style={{color: '#64748b', fontSize: '0.95rem'}}>Compartilhe o seu código exclusivo.</p>
                    </div>
                  </div>
                  <div className={styles.stepLine}></div>
                  <div className={styles.stepItem}>
                    <div className={styles.stepBadge}>2</div>
                    <div className={styles.stepInfo}>
                      <h3>Eles Assinam</h3>
                      <p style={{color: '#64748b', fontSize: '0.95rem'}}>O cliente usa o seu código e ganha desconto na hora.</p>
                    </div>
                  </div>
                  <div className={styles.stepLine}></div>
                  <div className={styles.stepItem}>
                    <div className={styles.stepBadge}>3</div>
                    <div className={styles.stepInfo}>
                      <h3>Você Ganha</h3>
                      <p style={{color: '#64748b', fontSize: '0.95rem'}}>Receba <strong>20% de comissão</strong> todo mês na sua conta.</p>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollAnimator>

            {/* WHITE LABEL: O BANNER PREMIUM */}
            <ScrollAnimator>
              <div className={styles.whitelabelPromo}>
                <div className={styles.wlContent}>
                  <span className={styles.wlBadge}>Franquia Premium</span>
                  <h2>Torne-se um Revendedor White Label</h2>
                  <p style={{color: '#94a3b8', fontSize: '1.1rem', lineHeight: '1.6'}}>
                    Tenha o ERP mais completo do mercado rodando no <strong>seu domínio</strong> e com a <strong>sua marca</strong>. Defina os seus próprios preços, lucre com 100% da margem que colocar em cima e escale o seu negócio de software.
                  </p>
                  <ul className={styles.wlBenefitsList}>
                    <li><Check size={20} color="#f59e0b" /> <strong>Sua marca e logo</strong> no painel</li>
                    <li><Check size={20} color="#f59e0b" /> <strong>Seu próprio domínio</strong> personalizado</li>
                    <li><Check size={20} color="#f59e0b" /> <strong>Liberdade total</strong> para precificar</li>
                    <li><CheckCircle2 size={20} color="#10b981" /> <strong style={{color: '#10b981'}}>Pague só quando vender</strong></li>
                  </ul>
                </div>
                
                <div className={styles.wlAction}>
                  <a href="https://api.whatsapp.com/send?phone=5511983493522&text=Ola,%20quero%20saber%20sobre%20o%20White%20Label" target="_blank" className={styles.whatsappBtn}>
                    <Phone size={24} />
                    Quero ser White Label
                  </a>
                  <p style={{fontSize: '0.8rem', color: '#64748b', textAlign: 'center', margin: 0}}>
                    Vagas rigorosamente limitadas por região.
                  </p>
                </div>
              </div>
            </ScrollAnimator>

          </div>
        </div>
      </section>

      <section id="precos" className={styles.section}>
        <div className={styles.container}>
          <div className={styles.sectionTitle}>
            <h2>Preço Transparente</h2>
            <p>Monte o plano ideal para sua empresa</p>
          </div>
          <ScrollAnimator><PricingCalculator /></ScrollAnimator>
        </div>
      </section>

      <Faq />
      <Testimonials />
      <CtaFinal />
    </>
  );
}